module.exports = __webpack_public_path__ + "img/location.005b4043.png";